module.exports = __webpack_public_path__ + "media/shelter_materials/shelter_banner_small_1x-e16f0cb8.png";